export default "__VITE_ASSET__CXk5Et4h__"